export default function auth_success_redirect(to, from, next) {
    if (localStorage.getItem('token')) {
        return next({
            name: 'dashboard.index'
        })
    }

    return next()
}